import _ from 'lodash'

class DBEntryLogs {
  constructor () {
    this.logs = []
  }

  static setPrototype (obj) {
    Object.setPrototypeOf(obj, DBEntryLogs.prototype)
    return obj
  }

  static get type () {
    return {
      CREATE: 'CREATE',
      UPDATE: 'UPDATE',
      STATUS_CHANGE: 'STATUS_CHANGE',
      UPDATE_STORAGE_INFO: 'UPDATE_STORAGE_INFO',
      REMINDER: 'REMINDER',
      EXTEND_DEATHLINE: 'EXTEND_DEATHLINE'
    }
  }

  getLogs (type = null) {
    if (type === null) {
      return this.logs
    }

    let toReturn = this.logs.filter(log => log.type === type).map((log) => log.value)
    return _.sortBy(toReturn, 'value.date')
  }

  getLog (type) {
    let toReturn = this.logs.find(log => {
      return log.type === type
    })

    return typeof toReturn === 'undefined' ? null : toReturn.value
  }

  getLastLog (type) {
    let logsOfType = this.logs.filter(log => log.type === type)
    let toReturn = _.sortBy(logsOfType, 'value.date')[0]

    return typeof toReturn === 'undefined' ? null : toReturn.value
  }

  addCreateLog (date = new Date()) {
    this.logs.push({
      type: DBEntryLogs.type.CREATE,
      value: {
        date: date
      }
    })
  }

  addUpdateLog (date = new Date()) {
    this.logs.push({
      type: DBEntryLogs.type.UPDATE,
      value: {
        date: date
      }
    })
  }
}

export default DBEntryLogs
